import { Group } from '@mantine/core';
import BadgeDeleted from 'components/Badge';
import { RemoteSourceRow } from 'components/tables/data/remote-source/types';
import P2Medium from 'components/typography/P2Medium';

/**
 * Column for the remote source name.
 */
export default function NameColumn({ data: { name, status } }: { data: RemoteSourceRow }) {
  const opacity = status ? 1 : 0.6;

  return (
    <Group spacing={8} noWrap align="center">
      {!status && <BadgeDeleted text="Neaktívny" />}
      <P2Medium color="gray.8" style={{ opacity }}>
        {name}
      </P2Medium>
    </Group>
  );
}
